<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col cols="12" sm="6">
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                color="orange"
                @click="helpDialog = true"
              >
                <v-icon small>fa-question</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.translator("showHelp") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-container>
        <v-form v-model="valid" @submit.prevent="getUsers">
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("userType") }}
              </div>
              <v-row>
                <v-col>
                  <v-select
                    :items="allUserTypes"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.user_type"
                    clearable
                    autofocus
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("name") }}
              </div>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="searchFields.name"
                    :placeholder="$vuetify.lang.translator('namePlaceHolder')"
                    type="text"
                    autocomplete="on"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("userName") }}
              </div>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="searchFields.mobile"
                    :placeholder="
                      $vuetify.lang.translator('userNamePlaceHolder')
                    "
                    type="text"
                    autocomplete="on"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("employer") }}
              </div>
              <v-row>
                <v-col>
                  <v-select
                    :items="allEmployers"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.employer_id"
                    clearable
                    @blur="getSearchContractors"
                    @change="getSearchContractors"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("contractor") }}
              </div>
              <v-row>
                <v-col>
                  <v-select
                    :items="allContractors"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.contractor_id"
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <div>
                {{ $vuetify.lang.translator("status") }}
              </div>
              <v-row>
                <v-col>
                  <v-select
                    :items="allUserStatus"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.is_active"
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto">
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="loading"
                type="submit"
              >
                <v-icon class="mx-2">fa-search</v-icon
                >{{ $vuetify.lang.translator("search") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-data-table
      fixed-header
      :header-props="{ sortIcon: 'fas fa-sort-amount-up-alt' }"
      :headers="headers"
      :items="items"
      :loading="loading"
      sort-by="updated_at"
      :sort-desc="true"
      :items-per-page="itemsPerPage"
      @update:items-per-page="updateRecordsPerPage"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
      :options.sync="options"
      :server-items-length="totalItems"
      :dense="showDense"
      class="elevation-2"
    >
      <template v-slot:top>
        <v-row align="center" class="my-2">
          <v-col cols="12" sm="6">
            <div class="mx-2">
              {{ $vuetify.lang.translator("searchResult") }}
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :class="
              $store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  color="primary"
                  @click.stop="newDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fa-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("new") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click="showDense = !showDense"
                  v-bind="attrs"
                  v-on="on"
                  :color="showDense ? 'success' : ''"
                >
                  <v-icon small>fas fa-compress-alt</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("compactView") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.index="{ item }">
        {{
          (options.page - 1) * options.itemsPerPage + items.indexOf(item) + 1
        }}
      </template>
      <template v-slot:item.is_active="{ item }">
        {{
          item.is_active
            ? $vuetify.lang.translator("active")
            : $vuetify.lang.translator("disabled")
        }}
      </template>
      <template v-slot:item.updated_at="{ item }">
        <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
          {{ item.updated_at | moment("jYYYY/jM/jD HH:mm") }}
        </div>
        <div class="ltr-text" v-else>
          {{ item.updated_at | moment("YYYY/M/D HH:mm") }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              @click.stop="openEdit(item.id, item.name)"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fa-edit</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("edit") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="error"
              @click.stop="confirmDelete(item.id, item.name)"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fa-trash</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("delete") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog
      v-model="newDialog"
      persistent
      @keydown.esc="closeNew"
      max-width="640"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $vuetify.lang.translator("createNewUser")
          }}</span>
        </v-card-title>
        <v-form ref="newForm" v-model="newValid" @submit.prevent="tryCreate">
          <v-tabs v-model="newTab">
            <v-tab>{{ $vuetify.lang.translator("profile") }}</v-tab>
            <v-tab>{{ $vuetify.lang.translator("privileges") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="newTab">
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="fields.user_type"
                      :rules="userTypeRules"
                      :label="$vuetify.lang.translator('userType') + ' *'"
                      :items="allUserTypes"
                      item-text="name"
                      item-value="id"
                      :placeholder="$vuetify.lang.translator('chooseAnOption')"
                      clearable
                      autofocus
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.name"
                      :rules="nameRules"
                      :label="$vuetify.lang.translator('name') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.mobile"
                      :rules="mobileRules"
                      :label="$vuetify.lang.translator('userName') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.password"
                      :rules="passwordRules"
                      :label="$vuetify.lang.translator('password') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="fields.employer_id"
                      :rules="employerRules"
                      :items="allEmployers"
                      item-text="name"
                      item-value="id"
                      :label="$vuetify.lang.translator('employer')"
                      clearable
                      @blur="getContractors"
                      @change="getContractors"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="fields.contractor_id"
                      :rules="contractorRules"
                      :items="allContractors"
                      item-text="name"
                      item-value="id"
                      :label="$vuetify.lang.translator('contractor')"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="fields.language"
                      :label="$vuetify.lang.translator('language')"
                      :items="allLanguages"
                      item-text="name"
                      item-value="id"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="fields.can_change_batch_status"
                      :label="
                        $vuetify.lang.translator('changeImageBatchStatus')
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="fields.can_delete_error"
                      :label="$vuetify.lang.translator('deleteError')"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="waitForNew">
              <v-icon class="mx-2">fa-save</v-icon
              >{{ $vuetify.lang.translator("create") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeNew">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      persistent
      @keydown.esc="closeEdit"
      max-width="640"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-form ref="editForm" v-model="editValid" @submit.prevent="tryEdit">
          <v-tabs v-model="editTab">
            <v-tab>{{ $vuetify.lang.translator("profile") }}</v-tab>
            <v-tab>{{ $vuetify.lang.translator("privileges") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="editTab">
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="fields.user_type"
                      :rules="userTypeRules"
                      :label="$vuetify.lang.translator('userType') + ' *'"
                      :items="allUserTypes"
                      item-text="name"
                      item-value="id"
                      :placeholder="$vuetify.lang.translator('chooseAnOption')"
                      clearable
                      autofocus
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.name"
                      :rules="nameRules"
                      :label="$vuetify.lang.translator('name') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.mobile"
                      :rules="mobileRules"
                      :label="$vuetify.lang.translator('userName') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fields.password"
                      :rules="passwordRules"
                      :label="$vuetify.lang.translator('password') + ' *'"
                      type="text"
                      autocomplete="on"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="fields.is_active"
                      :label="$vuetify.lang.translator('userStatus') + ' *'"
                      :items="allUserStatus"
                      item-text="name"
                      item-value="id"
                      autofocus
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="fields.employer_id"
                      :rules="employerRules"
                      :items="allEmployers"
                      item-text="name"
                      item-value="id"
                      :label="$vuetify.lang.translator('employer')"
                      clearable
                      @change="getContractors"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="fields.contractor_id"
                      :rules="contractorRules"
                      :items="allContractors"
                      item-text="name"
                      item-value="id"
                      :label="$vuetify.lang.translator('contractor')"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="fields.language"
                      :label="$vuetify.lang.translator('language')"
                      :items="allLanguages"
                      item-text="name"
                      item-value="id"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <VuePersianDatetimePicker
                      type="datetime"
                      input-class="vpdp-input"
                      :format="
                        $store.getters.LANGUAGE == 'fa'
                          ? 'jYYYY/jMM/jDD HH:mm'
                          : 'YYYY/MM/DD HH:mm'
                      "
                      input-format="YYYY-MM-DDTHH:mm:ssZ"
                      :disabled="true"
                      color="dimgray"
                      :label="$vuetify.lang.translator('createDate')"
                      v-model="createdAt"
                    ></VuePersianDatetimePicker>
                  </v-col>

                  <v-col cols="12" md="6">
                    <VuePersianDatetimePicker
                      type="datetime"
                      input-class="vpdp-input"
                      :format="
                        $store.getters.LANGUAGE == 'fa'
                          ? 'jYYYY/jMM/jDD HH:mm'
                          : 'YYYY/MM/DD HH:mm'
                      "
                      input-format="YYYY-MM-DDTHH:mm:ssZ"
                      :disabled="true"
                      color="dimgray"
                      :label="$vuetify.lang.translator('updateDate')"
                      v-model="updatedAt"
                    ></VuePersianDatetimePicker>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="fields.can_change_batch_status"
                      :label="
                        $vuetify.lang.translator('changeImageBatchStatus')
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="fields.can_delete_error"
                      :label="$vuetify.lang.translator('deleteError')"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="waitForEdit">
              <v-icon class="mx-2">fa-save</v-icon
              >{{ $vuetify.lang.translator("change") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeEdit">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="640px"
      persistent
      @keydown.esc="closeDelete"
    >
      <v-card>
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDelete">{{
            $vuetify.lang.translator("no")
          }}</v-btn>
          <v-btn
            color="error"
            @click="tryDelete"
            :disabled="waitForDelete"
            :loading="waitForDelete"
            >{{ $vuetify.lang.translator("yes") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('usersHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { required, max, min, len } from "@/helpers/validations";
import { handleError } from "@/helpers/helper";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Users",
  components: {
    VuePersianDatetimePicker
  },
  data: () => ({
    breadcrumbsItems: [],
    headers: [],
    items: [],
    itemsPerPage: 0,
    options: {},
    totalItems: 0,
    newValid: false,
    editValid: false,
    fields: {
      id: 0,
      name: "",
      mobile: "",
      password: "",
      user_type: null,
      employer_id: null,
      contractor_id: null,
      is_active: null,
      language: "en",
      can_change_batch_status: false,
      can_delete_error: false
    },
    createdAt: null,
    updatedAt: null,
    userTypeRules: [],
    nameRules: [],
    mobileRules: [],
    passwordRules: [],
    employerRules: [],
    contractorRules: [],
    loading: true,
    newDialog: false,
    waitForNew: false,
    deleteDialog: false,
    dialogTitle: "",
    waitForDelete: false,
    idToBeDeleted: 0,
    editDialog: false,
    waitForEdit: false,
    showPassword: false,
    allUserTypes: [],
    allEmployers: [],
    allContractors: [],
    allUserStatus: [],
    showDense: true,
    helpDialog: false,
    newTab: 0,
    editTab: 0,
    valid: false,
    searchFields: {
      user_type: null,
      name: null,
      mobile: null,
      is_active: null,
      employer_id: null,
      contractor_id: null
    },
    allLanguages: [
      { id: "fa", name: "فارسی" },
      { id: "en", name: "English" }
    ]
  }),
  watch: {
    options: {
      handler() {
        this.getUsers();
      }
    },
    showDense: function() {
      this.$store.dispatch("saveShowDense", this.showDense ? "show" : "hide");
    }
  },
  created() {
    this.itemsPerPage = parseInt(this.$store.getters.PERPAGE);
    this.showDense = this.$store.getters.SHOWDENSE === "show";

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("management")
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("users"),
      to: { name: "Users" }
    });

    this.headers.push({
      text: this.$vuetify.lang.translator("row"),
      value: "index",
      sortable: false,
      align: "center"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("name"),
      value: "name"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("userName"),
      value: "mobile",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("userType"),
      value: "user_type_title"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("status"),
      value: "is_active"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("employer"),
      value: "employer_name",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("contractor"),
      value: "contractor_name",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("updateDate"),
      value: "updated_at"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("operations"),
      value: "actions",
      sortable: false,
      align: "center"
    });

    this.allUserTypes.push({
      id: 1,
      name: this.$vuetify.lang.translator("superAdmin")
    });
    this.allUserTypes.push({
      id: 2,
      name: this.$vuetify.lang.translator("admin")
    });
    this.allUserTypes.push({
      id: 3,
      name: this.$vuetify.lang.translator("employerExpert")
    });
    this.allUserTypes.push({
      id: 4,
      name: this.$vuetify.lang.translator("employerManager")
    });
    this.allUserTypes.push({
      id: 5,
      name: this.$vuetify.lang.translator("contractorPilot")
    });
    this.allUserTypes.push({
      id: 6,
      name: this.$vuetify.lang.translator("contractorExpert")
    });
    this.allUserTypes.push({
      id: 7,
      name: this.$vuetify.lang.translator("contractorManager")
    });

    this.allUserStatus.push({
      id: true,
      name: this.$vuetify.lang.translator("active")
    });
    this.allUserStatus.push({
      id: false,
      name: this.$vuetify.lang.translator("disabled")
    });

    this.checkPrivileges();
    this.getEmployers();
  },
  methods: {
    checkPrivileges() {
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [1, 2];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    getEmployers() {
      this.fields.employer_id = null;
      this.fields.contractor_id = null;
      var self = this;
      this.$http
        .get("/employer/list/")
        .then(function(response) {
          self.allEmployers = response.data;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    getContractors() {
      this.fields.contractor_id = null;
      if (this.fields.employer_id === null) {
        this.allContractors = [];
      } else {
        var self = this;
        this.$http
          .get("/employer/" + self.fields.employer_id + "/contractor/list/")
          .then(function(response) {
            self.allContractors = response.data;
          })
          .catch(function(error) {
            let result = handleError(
              error,
              self.$toasted,
              self.$router,
              self.$store
            );
            for (var item in result) {
              self.$toasted.error(result[item], {
                duration: 5000,
                keepOnHover: true,
                className:
                  self.$store.getters.LANGUAGE == "fa"
                    ? "vazir-font-fd"
                    : "vazir-font",
                iconPack: "fontawesome",
                icon: "exclamation-triangle",
                position: "top-center"
              });
            }
          });
      }
    },
    getSearchContractors() {
      this.searchFields.contractor_id = null;
      if (this.searchFields.employer_id === null) {
        this.allContractors = [];
      } else {
        var self = this;
        this.$http
          .get(
            "/employer/" + self.searchFields.employer_id + "/contractor/list/"
          )
          .then(function(response) {
            self.allContractors = response.data;
          })
          .catch(function(error) {
            let result = handleError(
              error,
              self.$toasted,
              self.$router,
              self.$store
            );
            for (var item in result) {
              self.$toasted.error(result[item], {
                duration: 5000,
                keepOnHover: true,
                className:
                  self.$store.getters.LANGUAGE == "fa"
                    ? "vazir-font-fd"
                    : "vazir-font",
                iconPack: "fontawesome",
                icon: "exclamation-triangle",
                position: "top-center"
              });
            }
          });
      }
    },
    getUsers() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      var parameters = null;
      if (sortBy[0]) {
        let sort_by = sortBy[0];
        if (sort_by === "user_type_title") {
          sort_by = "user_type";
        }
        parameters = {
          page: page,
          size: itemsPerPage,
          sort: (sortDesc[0] ? "-" : "") + sort_by
        };
      } else {
        parameters = {
          page: page,
          size: itemsPerPage
        };
      }
      var self = this;
      this.$http
        .post("/user/search/", this.searchFields, { params: parameters })
        .then(function(response) {
          self.items = response.data.results;
          self.totalItems = response.data.count;
          if (self.totalItems === 0) {
            self.$toasted.info(self.$vuetify.lang.translator("noDataText"), {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loading = false;
        });
    },
    tryCreate() {
      this.userTypeRules = [
        required(this.$vuetify.lang.translator("userType"), this.$vuetify)
      ];
      this.nameRules = [
        required(this.$vuetify.lang.translator("name"), this.$vuetify),
        max(1000, this.$vuetify.lang.translator("name"), this.$vuetify)
      ];
      this.mobileRules = [
        required(this.$vuetify.lang.translator("userName"), this.$vuetify),
        len(11, this.$vuetify.lang.translator("userName"), this.$vuetify)
      ];
      this.passwordRules = [
        min(6, this.$vuetify.lang.translator("password"), this.$vuetify),
        max(30, this.$vuetify.lang.translator("password"), this.$vuetify)
      ];
      if (this.fields.user_type >= 3 && this.fields.user_type <= 4) {
        this.employerRules = [
          required(this.$vuetify.lang.translator("employer"), this.$vuetify)
        ];
      } else {
        this.employerRules = [];
      }
      if (this.fields.user_type >= 5 && this.fields.user_type <= 7) {
        this.contractorRules = [
          required(this.$vuetify.lang.translator("contractor"), this.$vuetify)
        ];
      } else {
        this.contractorRules = [];
      }
      let self = this;
      setTimeout(function() {
        if (self.$refs.newForm.validate()) {
          let data = {
            name: self.fields.name,
            mobile: self.fields.mobile,
            password: self.fields.password,
            user_type: self.fields.user_type,
            can_change_batch_status: self.fields.can_change_batch_status,
            can_delete_error: self.fields.can_delete_error,
            language: self.fields.language
          };
          if (self.fields.user_type >= 3 && self.fields.user_type <= 4) {
            data.employer_id = self.fields.employer_id;
          }
          if (self.fields.user_type >= 5 && self.fields.user_type <= 7) {
            data.contractor_id = self.fields.contractor_id;
          }
          self.waitForNew = true;
          self.$http
            .post("/user/", data)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("newUserCreated"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getUsers();
              self.newDialog = false;
              self.resetData();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForNew = false;
            });
        }
      });
    },
    closeNew() {
      this.resetData();
      this.newDialog = false;
    },
    openEdit(id, name) {
      this.dialogTitle = this.$vuetify.lang.translator("editUser", name);
      var self = this;
      this.$http
        .get("/user/" + id + "/")
        .then(function(response) {
          self.fields.id = response.data.id;
          self.fields.name = response.data.name;
          self.fields.mobile = response.data.mobile;
          self.fields.password = response.data.password;
          self.fields.user_type = response.data.user_type;
          self.fields.employer_id = response.data.employer_id;
          self.fields.contractor_id = response.data.contractor_id;
          self.fields.is_active = response.data.is_active;
          self.fields.can_change_batch_status =
            response.data.can_change_batch_status;
          self.fields.can_delete_error = response.data.can_delete_error;
          self.fields.language = response.data.language;
          self.createdAt = response.data.created_at;
          self.updatedAt = response.data.updated_at;
          self.editDialog = true;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    tryEdit() {
      this.userTypeRules = [
        required(this.$vuetify.lang.translator("userType"), this.$vuetify)
      ];
      this.nameRules = [
        required(this.$vuetify.lang.translator("name"), this.$vuetify),
        max(1000, this.$vuetify.lang.translator("name"), this.$vuetify)
      ];
      this.mobileRules = [
        required(this.$vuetify.lang.translator("userName"), this.$vuetify),
        len(11, this.$vuetify.lang.translator("userName"), this.$vuetify)
      ];
      if (this.fields.password) {
        this.passwordRules = [
          min(6, this.$vuetify.lang.translator("password"), this.$vuetify),
          max(30, this.$vuetify.lang.translator("password"), this.$vuetify)
        ];
      }
      let self = this;
      setTimeout(function() {
        if (self.$refs.editForm.validate()) {
          let data = {
            name: self.fields.name,
            mobile: self.fields.mobile,
            user_type: self.fields.user_type,
            is_active: self.fields.is_active,
            can_change_batch_status: self.fields.can_change_batch_status,
            can_delete_error: self.fields.can_delete_error,
            language: self.fields.language
          };
          if (self.fields.password) {
            data.password = self.fields.password;
          }
          if (self.fields.user_type >= 3 && self.fields.user_type <= 4) {
            data.employer_id = self.fields.employer_id;
          }
          if (self.fields.user_type >= 5 && self.fields.user_type <= 7) {
            data.contractor_id = self.fields.contractor_id;
          }
          self.waitForEdit = true;
          self.$http
            .put("/user/" + self.fields.id + "/", data)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("userEdited"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getUsers();
              self.editDialog = false;
              self.resetData();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForEdit = false;
            });
        }
      });
    },
    closeEdit() {
      this.resetData();
      this.editDialog = false;
    },
    confirmDelete(id, name) {
      this.idToBeDeleted = id;
      this.dialogTitle = this.$vuetify.lang.translator(
        "sureToDeleteUser",
        name
      );
      this.deleteDialog = true;
    },
    tryDelete() {
      if (this.idToBeDeleted === 0) {
        this.$toasted.error(this.$vuetify.lang.translator("selectAUser"), {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      this.waitForDelete = true;
      let self = this;
      self.$http
        .delete("/user/" + this.idToBeDeleted + "/")
        .then(() => {
          self.$toasted.success(self.$vuetify.lang.translator("userDeleted"), {
            duration: 5000,
            keepOnHover: true,
            className:
              self.$store.getters.LANGUAGE == "fa"
                ? "vazir-font-fd"
                : "vazir-font",
            iconPack: "fontawesome",
            icon: "check",
            position: "top-center"
          });
          self.getUsers();
          self.deleteDialog = false;
        })
        .catch(error => {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForDelete = false;
        });
    },
    closeDelete() {
      this.idToBeDeleted = 0;
      this.deleteDialog = false;
    },
    resetData() {
      this.userTypeRules = [];
      this.nameRules = [];
      this.mobileRules = [];
      this.passwordRules = [];
      this.employerRules = [];
      this.contractorRules = [];

      this.fields.id = 0;
      this.fields.name = "";
      this.fields.mobile = "";
      this.fields.password = "";
      this.fields.user_type = null;
      this.fields.employer_id = null;
      this.fields.contractor_id = null;
      this.fields.can_change_batch_status = false;
      this.fields.can_delete_error = false;
      this.fields.is_active = null;
      this.fields.language = "en";

      this.createdAt = null;
      this.updatedAt = null;

      this.newTab = 0;
      this.editTab = 0;
    },
    updateRecordsPerPage(rowsPerPage) {
      this.$store.dispatch("saveRecordsPerPage", rowsPerPage);
    }
  }
};
</script>
